import { fetchAPI } from '../../api';
import { Role } from '../../types';

export const fetchPermissions = async () => {
  const permissionsResponse = await fetchAPI<{ permissions: string[] }>(
    `v1/permissions`,
    {
      method: 'GET',
    }
  );
  return permissionsResponse.permissions;
};

export const fetchGroups = () => {
  return fetchAPI<Role[]>(`v1/groups`, {
    method: 'GET',
  });
};

export const saveGroup = (role: Role) => {
  return fetchAPI(`v1/groups/${role.name}`, {
    method: 'PUT',
    body: {
      permissions: role.permissions,
    },
  });
};

export const createGroup = async (role: Role) => {
  return fetchAPI(`v1/groups`, {
    method: 'POST',
    body: {
      name: role.name,
      permissions: role.permissions,
    },
  });
};

export const deleteGroup = (roleName: string) => {
  return fetchAPI(`v1/groups/${roleName}`, {
    method: 'DELETE',
  });
};
